<template>
    <div>
        <accordion level3 id="sub_aneel10_1" title="Gerar XML" sub accordion="sub_aneel10_1" visible>
            <div class="p-3 row">
                <input-text class="col-12 col-md-4" label="Versão" :disabled="readonly" v-model="form.versao" ref="form1-versao" required/>
                <input-date-time class="col-12 col-md-4" label="Data inicio ODS" :disabled="readonly" v-model="form.dataInicioODS" ref="form1-dfimods" required/>              
                <input-date-time class="col-12 col-md-4" label="Data final ODS" :disabled="readonly" v-model="form.dataFimODS" ref="form1-dfim" required/>              

                <div class="col-12" v-if="!readonly">
                    <b-button v-if="permissao.c" variant="success" @click="$emit('salvar',form)">
                        <i class="fa-solid fa-file-code mr-2"></i>
                        Gerar XML
                    </b-button>
                </div>
                <div class="col-12 mt-3">
                    <h6>Lista de XML's Gerados</h6>
                    <b-table head-variant="dark" hover :fields="table.fields" :items="itens">
                        <template  #cell(actions)="data">
                            <div class="d-inline-flex">
                                <b-button variant="flat-primary" class="mr-2" @click="$emit('download', `${data.item.id}`)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                                <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar', data.item.id)"><i class="fas fa-trash"></i></b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>
        </accordion>
        <accordion level3 id="sub_aneel10_2" title="Relatório PDF" sub accordion="sub_aneel10_2" visible>
            <div class="p-3 row">
                <input-date-time class="col-12 col-md-3" :disabled="readonly" label="Data do envio" v-model="form2.data" ref="form2-data" required type="date"/>
                <input-text class="col-12 col-md-3" :disabled="readonly" label="Versão PDF" v-model="form2.versao" ref="form2-versao" required/>
                <div class="col-12 mb-2">
                    <div class="text-muted">
                        Relatório PDF
                    </div> 
                    <upload 
                        id="aneel12_2"
                        tituloArquivo="Arrastar Arquivo" 
                        selecioneArquivo="Selecionar Arquivo" 
                        type=".pdf"
                        
                        @upload="(file, nomeArquivo)=> {                   
                            form2.nomeArquivoAWS = nomeArquivo;
                            form2.conteudoBase64 = file;
                        }" />
                </div>   
                <div class="col-12" v-if="!readonly">
                    <b-button v-if="permissao.c" variant="success" @click="$emit('salvar',form2)">
                        <i class="fa-solid fa-cloud-arrow-up mr-2"></i>
                        Upload relatório PDF
                    </b-button>
                </div>     
                <div class="col-12 mt-3">
                    <h6>Lista de relatórios</h6>
                    <b-table head-variant="dark" hover :fields="table.fields2" :items="itens2">
                        <template  #cell(actions)="data">
                            <div class="d-inline-flex">
                                <b-button variant="flat-primary" v-if="!readonly" class="mr-2" @click="$emit('download2', data.item.id)"><i class="fa-solid fa-cloud-arrow-down"></i></b-button>
                                <b-button variant="flat-danger" v-if="!readonly && permissao.d" class="mr-2" @click="$emit('deletar2', data.item.id)"><i class="fas fa-trash"></i></b-button>
                            </div>
                        </template>
                    </b-table>
                </div>
            </div>        
        </accordion>
    </div>
</template>
<script>

import InputText from '@/components/inputs/InputText';
import InputDateTime from '@/components/inputs/InputDateTime';
import Upload from '@/components/upload/Upload';
import Accordion from '@/components/card/Accordion';

import helpers from '@/common/utils/helpers';

import {FormMixin} from '@/common/mixins/FormMixin';

export default {
    name: 'Aneel10',
    mixins: [FormMixin],
    props: {
        itens : {            
            default: () => []
        },
        itens2 : {            
            default: () => []
        },
        projetoEditavel : {
            type : Boolean,
            default : false
        }
    },
    components: {
        InputText,
        InputDateTime,
        Upload,
        Accordion
    }, 
    data: () => ({

        form : {
            versao: 0,
            dataInicioODS : "",
            dataFimODS : "",
        },
        form2 : {
            form2 : true,
            arquivoObrigatorio : [
                {
                    nomeCampo : 'Comprovante',
                    campo : 'conteudoBase64',
                }
            ],
            data: null,
            nomeArquivoAWS: "",
            versao: 0,
            conteudoBase64: null
        },


        table : {
            fields : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão"},
                { key: "dataCriacao", label:"Data de emissão",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ],
            
            fields2 : [
                { key: "nomeArquivoAWS", label:"Nome do arquivo"},
                { key: "versao", label:"Versão"},
                { key: "data", label:"Data de envio",
                    formatter: (value) => helpers.formatarDataBr(value)
                },
                { key: "actions", label:"Ações"},
            ]
        },
    }),
    watch: {
        itens: {
            handler: function(newValue) {
                this.form.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        },
        itens2: {
            handler: function(newValue) {
                this.form2.versao = newValue.length ? newValue[newValue.length - 1].versao + 1 : 1;
            },
            deep: true,
            immediate: true
        }
    },
    computed :{
        permissao() {
            return this.$store.getters['app/retornaPermissao']('ProjetosPdObrigacoesAneel');
        },
        readonly :function(){
            return this.$route.name != 'projeto-detalhamento' || !this.projetoEditavel
        }
    }
}
</script>
<style lang="">
    
</style>